import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    StagesetsForPipelineList,
    StagesetsForPipelineList_stagesets as Stageset,
} from 'nutshell-graphql-types';

import GET_STAGESETS from '../queries/get-stagesets-for-pipeline-list.graphql';

export const useGetStagesetsForSalesAutomation = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    stagesets: Stageset[];
} => {
    const {loading, data, error} = useQuery<StagesetsForPipelineList, Record<any, any>>(
        GET_STAGESETS,
        {
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        stagesets: data && data.stagesets ? data.stagesets : [],
    };
};
